import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"

const FeaturesPreview = ({
  bgImage,
  menuColor,
  textColor,
  font,
  menuItems = [],
}) => {
  return (
    <PhoneArea>
      <div
        style={{
          width: "105%",
          height: "10px",
          backgroundColor: menuColor,
          marginLeft: "-5px",
        }}
      />
      <div
        style={{
          display: "flex",
          width: "105%",
          height: "105%",
          marginLeft: "-5px",
          flex: "1",
        }}
      >
        <div
          style={{
            backgroundColor: menuColor,
            display: "flex",
            flexDirection: "column",
            flex: "1 1 100%",
            maxWidth: "65%",
            maxHeight: "100%",
            boxSizing: "border-box",
          }}
        >
          <span
            className="my-2 ms-1 "
            style={{
              borderBottom: "1px solid",
              width: "90%",
              color: textColor,
            }}
          >
            <i
              className="bx bx-chevron-left font-size-24"
              style={{ color: "black" }}
            />
            <p
              style={{
                display: "inline",
                fontSize: "14px",
                verticalAlign: "super",
                color: textColor,
                fontFamily: font,
              }}
            >
              Exit
            </p>
          </span>
          {menuItems?.map((item, index) => {
            if (item?.status) {
              return (
                <span key={index} className="my-2 ms-2 ">
                  <img
                    src={item?.icon?.url}
                    className="me-1"
                    width="auto"
                    height="15px"
                  />
                  <p
                    style={{
                      display: "inline",
                      color: textColor,
                      fontFamily: font,
                    }}
                  >
                    {item?.label}
                  </p>
                </span>
              )
            }
          })}
        </div>
        <div
          style={{
            backgroundImage: `url(${bgImage?.editedImage})`,
            backgroundColor: "gray",
            backgroundSize: "cover",
            backgroundPosition: "left center",
            flex: "1 1 100%",
            maxWidth: "35%",
            maxHeight: "100%",
            boxSizing: "border-box",
            boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 40%)",
          }}
        />
      </div>
    </PhoneArea>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  bgImage: selector(state, "design.bgImage"),
  menuColor: selector(state, "design.primaryMenuColor"),
  textColor: selector(state, "design.secondaryTextColor"),
  font: selector(state, "design.font"),
  menuItems: selector(state, "features.menu"),
})

export default connect(mapStateToProps)(FeaturesPreview)
